import React, { useState } from 'react';
import { auth } from '../config/firebaseConfig'; // Firebase config’dan auth import ediliyor
import { signInWithEmailAndPassword } from 'firebase/auth'; // Authentication fonksiyonu
import 'bootstrap/dist/css/bootstrap.min.css'; // Bootstrap CSS

const Login = () => {
  const [email, setEmail] = useState(''); // E-posta alanı
  const [password, setPassword] = useState(''); // Şifre alanı
  const [error, setError] = useState(null); // Hata mesajları için
  const [loading, setLoading] = useState(false); // Yükleme durumu

  // Giriş yapma işlemi
  const handleLogin = async (e) => {
    e.preventDefault();
    if (!email.trim() || !password.trim()) {
      setError('E-posta ve şifre boş olamaz.');
      return;
    }

    setLoading(true); // Yükleme başlasın
    setError(null); // Önceki hataları sıfırla
    try {
      await signInWithEmailAndPassword(auth, email, password);
      window.location.href = '/'; // Başarılı girişte admin paneline yönlendir
    } catch (error) {
      setError('Giriş başarısız: ' + error.message); // Hata mesajını göster
    } finally {
      setLoading(false); // Yükleme bitsin
    }
  };

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="card shadow-sm">
            <div className="card-body">
              <h2 className="card-title text-center mb-4">Giriş Yap</h2>

              {error && (
                <div className="alert alert-danger" role="alert">
                  {error}
                </div>
              )}

              <form onSubmit={handleLogin}>
                <div className="mb-3">
                  <label htmlFor="email" className="form-label">
                    E-posta
                  </label>
                  <input
                    type="email"
                    id="email"
                    className="form-control"
                    placeholder="E-posta adresinizi girin"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    disabled={loading} // Yükleme sırasında devre dışı bırak
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="password" className="form-label">
                    Şifre
                  </label>
                  <input
                    type="password"
                    id="password"
                    className="form-control"
                    placeholder="Şifrenizi girin"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    disabled={loading} // Yükleme sırasında devre dışı bırak
                  />
                </div>
                <button
                  type="submit"
                  className="btn btn-primary w-100"
                  disabled={loading} // Yükleme sırasında butonu devre dışı bırak
                >
                  {loading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Giriş Yapılıyor...
                    </>
                  ) : (
                    'Giriş Yap'
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;